import * as configs           from '../../shared/services/general/configs';
import React, { useEffect, useState } from 'react';
import SliderCarousel from '../carousel/slider/slider-carousel';
import SimpleLinearCarousel from '../carousel/simple-linear/simple-linear-carousel';
import Footer from '../footer/footer';
import { useConfigApp } from '../../shared/services/general/app-context';
import ProgramCarousel from '../carousel/program/program-carousel';
import { Helmet } from 'react-helmet';
import { useSeo } from '../../shared/services/general/seoManager';
import SkeletonLoader from '../skeleton-loader/skeleton-loader';

function BaseEntity ({ data, baseUrl = 'movies' }) {
	const configApp = useConfigApp();
	const url = window.location.origin;
	const [logo, setLog] = useState(null);
	const { setSeoData } = useSeo();
	const [isDesktop, setIsDesktop] = useState(window.innerWidth > 980);


	useEffect(() => {
		const handleResize = () => {
			setIsDesktop(window.innerWidth > 980);
		};
		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	useEffect(() => {
		if (configApp?.logo) {
			setLog(require(`../../assets/images/${configApp?.logo}`).default)
		}
	}, [configApp]);

	useEffect(() => {
		if (baseUrl === 'movies') {
			setSeoData({
				title: `لیست فیلم‌ها در ${configApp?.title}`,
				image: url + logo,
				description: `فیلم‌های مختلف با کیفیت و تنوع بالا شامل ژانرهای اکشن، درام، کمدی و ...`,
			});
		} else if (baseUrl === 'series') {
			setSeoData({
				title: `لیست سریال‌ها در ${configApp?.title}`,
				image: url + logo,
				description: `سریال‌های تلویزیونی با ژانرهای مختلف از جمله درام، علمی-تخیلی، هیجان‌انگیز و ...`,
			});
		}
	}, [setSeoData, logo, configApp]);

	const renderSchemaMovie = () => {
		return (
			<Helmet>
				<script type="application/ld+json">
					{JSON.stringify({
						"@context": "http://schema.org",
						"@type": "CollectionPage",
						"name": `لیست فیلم‌ها در سایت ${configApp?.title || configApp?.titleEn}`,
						"description": `در این صفحه مجموعه‌ای از فیلم‌های متنوع با ژانرهای مختلف از سراسر جهان در سایت ${configApp?.title || configApp?.titleEn} قابل مشاهده و انتخاب هستند.`,
						'about': {
							'@type': 'Movie',
							'name': 'فیلم',
							'description': 'فیلم‌های مختلف با کیفیت و تنوع بالا شامل ژانرهای اکشن، درام، کمدی و ...',
							'mainEntity': {
								'@type': 'ItemList',
								'itemListElement': {
									'@type': 'Movie',
									'url': url,
									'name': `فیلم‌های ${configApp?.title || configApp?.titleEn}`,
								},
							},
							'provider': {
								'@type': 'Organization',
								'name': configApp?.title || configApp?.titleEn,
								'url': url,
								...(logo && {
									'logo': url + logo,
								})
							},
						},

					})}
				</script>
			</Helmet>
		);
	}

	const renderSchemaSeries = () => {
		return (
			<Helmet>
				<script type="application/ld+json">
					{JSON.stringify({
						'@context': 'http://schema.org',
						'@type': 'CollectionPage',
						'name': `لیست سریال‌ها در سایت ${configApp?.title || configApp?.titleEn}`,
						'description': 'در این صفحه لیستی از سریال‌های محبوب، جدید و قدیمی با موضوعات گوناگون از سراسر جهان ارائه شده است.',
						'about': {
							'@type': 'TVSeries',
							'name': 'سریال',
							'description': 'سریال‌های تلویزیونی با ژانرهای مختلف از جمله درام، علمی-تخیلی، هیجان‌انگیز و ...',
						},
						'mainEntity': {
							'@type': 'ItemList',
							'itemListElement': {
								'@type': 'TVSeries',
								'url': url + '/series',
								'name': `سریال‌های ${configApp?.title || configApp?.titleEn}`,
							},
						},
						'provider': {
							'@type': 'Organization',
							'name': configApp?.title || configApp?.titleEn,
							'url': url,
							...(logo && {
								'logo': url + logo,
							})
						},
					})}
				</script>
			</Helmet>
		);
	}

	const skeletonDesktop = () => {
		return(
			<>
				<br />
				<br />
				<SkeletonLoader type="big-slider" borderRadius={16} count={4} />
				{baseUrl === 'movies' ? <SkeletonLoader type="mini-slider" count={16} /> : ''}
				<SkeletonLoader type="slider" count={12} />
				<SkeletonLoader type="slider" count={12} />
				<SkeletonLoader type="slider" count={12} />
			</>
		)
	}

	const skeletonMobile = () => {
		return(
			<>
				<SkeletonLoader type="rectangle" count={1} width="100vw" height="130vw" borderRadius={'16px'} />
				<div style={{ marginTop: '32px', marginBottom: '45px', paddingRight: '12px', paddingLeft: '12px' }}>
					<SkeletonLoader type="mini-slider" count={5} height="40px" />
				</div>
				<div style={{ marginBottom: '19px', paddingRight: '12px', paddingLeft: '12px' }}>
					<SkeletonLoader type="slider" count={8}/>
				</div>
				<div style={{ marginBottom: '19px', paddingRight: '12px', paddingLeft: '12px' }}>
					<SkeletonLoader type="slider" count={8}/>
				</div>
				<div style={{ marginBottom: '19px', paddingRight: '12px', paddingLeft: '12px' }}>
					<SkeletonLoader type="slider" count={8}/>
				</div>
			</>
		)

	}

	// if (!data || data.length === 0) {
	if (!data || data.length === 0) {
		return (
			<>
				{
					isDesktop ? skeletonDesktop() : skeletonMobile()
				}
			</>
		);
	}

	return (
		<>
			{baseUrl === 'movies' ? renderSchemaMovie() : (baseUrl === 'series' ? renderSchemaSeries() : '')}
			{
				data.map((value, index) => {
					if ((value && value.hasOwnProperty(configs.render_type.slider.toLowerCase())) || (value && value?.render?.type === configs.render_type.slider)) {
						return (
							<>
								<SliderCarousel data={value.slider ? value.slider : value} baseUrl={baseUrl}/>
							</>
						);
					} else if ((value && value.hasOwnProperty(configs.render_type.genres.toLowerCase())) || (value && value?.render?.type === configs.render_type.genres)) {
						return (
							<SimpleLinearCarousel data={value.genres ? value.genres : value} baseUrl={baseUrl}/>
						);
					} else if ((value && value.hasOwnProperty(configs.render_type.list.toLowerCase())) || (value && value?.render?.type === configs.render_type.carousel)) {
						return (
							<div key={index}>
								<ProgramCarousel data={value.list ? value.list : value}
												 type={baseUrl !== 'movies' ? baseUrl : 'MOVIE'}/>
							</div>
						);
					}
				})
			}

			{(configApp?.titleEn === 'bebin' && !configApp?.sub_domain) && <Footer />}
		</>
	);
}

export default BaseEntity;
